/// <amd-module name="VSS/Features/Identities/IdentityDetailsProvider" />
import * as React from "react";
import {
    IdentitiesGetConnectionsResponseModel as IPersonaConnections,
    IIdentity,
    IVssIdentityService,
    VssIdentityServiceName
} from "VSS/Features/Identities/IdentityService";
import { IVssPageContext } from "VSS/Platform/Context";
import { TeamMember } from "VSS/Platform/Contracts/WebApi";
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import { IdentityCard } from "VSSUI/IdentityCard";
import { IIdentityDetailsProvider } from "VSSUI/VssPersona";

export class IdentityDetailsProvider implements IIdentityDetailsProvider {
    private identityService: IVssIdentityService;
    private pageData: IPageData;
    private member: TeamMember;

    public constructor(pageContext: IVssPageContext, member: TeamMember) {
        this.identityService = pageContext.getService<IVssIdentityService>(VssIdentityServiceName);
        this.pageData = pageContext.getService<IVssPageService>("IVssPageService").getData()!;
        this.member = member;
    }

    public getIdentityImageUrl = (): string | undefined => {
        const { identity } = this.member;
        return (identity._links && identity._links.avatar && identity._links.avatar.href) || identity.imageUrl;
    };

    public getDisplayName = (): string => {
        return this.member.identity.displayName;
    };

    public onRequestConnectionInformation = (
        entity: IIdentity,
        getDirectReports?: boolean | undefined
    ): IPersonaConnections | PromiseLike<IPersonaConnections> => {
        return this.identityService.getConnections(entity, getDirectReports);
    };

    public getEntityFromUniqueAttribute = (entityId: string): IIdentity | PromiseLike<IIdentity> => {
        return this.identityService
            .searchIdentitiesAsync(entityId, ["user"], this.pageData.isHosted ? ["ims", "source"] : ["ims", "source", "ad"], "uid")
            .then(x => x[0]);
    };

    public onRenderPersonaCard = (target: HTMLElement, onDismiss: () => void): JSX.Element => {
        return (
            <IdentityCard
                uniqueAttribute={this.member.identity.uniqueName}
                target={target}
                onDismissCallback={onDismiss}
                displayName={this.member.identity.displayName}
                onRequestConnectionInformation={this.onRequestConnectionInformation}
                getEntityFromUniqueAttribute={this.getEntityFromUniqueAttribute}
            />
        );
    };
}
